import {View} from 'react-native';
import _ from 'lodash';

import sy from '~/styles';
import {Text, ServiceRequestStatusIcon} from '~/components/controls';

import {STATUS_DESCRIPTIONS} from '~/types/statuses';

import TextsmsIcon from '~/images/md-icons/textsms/materialicons/24px.svg';
import EmailIcon from '~/images/md-icons/email/materialicons/24px.svg';

const Activity = ({
  attributes,
  status,
  display_timestamp,
  is_last_activity,
}) => {
  if (attributes?.type === 'SMS') {
    return (
      <View
        style={[
          sy['rounded-lg'],
          sy['bg-white'],
          sy['py-2'],
          sy['px-4'],
          sy['flex-row'],
          sy['items-center'],
          sy['gap-4'],
        ]}>
        <TextsmsIcon
          fill={!is_last_activity ? '#828282' : '#4a4a49'}
          width={18}
          height={18}
        />
        <View
          style={[
            sy['flex-1'],
            sy['flex-row'],
            sy['justify-between'],
            {paddingRight: 10},
          ]}>
          <Text
            style={[sy.smallMedium, !is_last_activity && sy['text-lightgray']]}>
            {status === 'SentFailed'
              ? 'SMS verzenden mislukt'
              : 'SMS verzonden'}
          </Text>
          <Text style={[sy.small]}>{display_timestamp.format('H:mm')}</Text>
        </View>
      </View>
    );
  } else if (attributes?.type === 'Email') {
    return (
      <View
        style={[
          sy['rounded-lg'],
          sy['bg-white'],
          sy['py-2'],
          sy['px-4'],
          sy['flex-row'],
          sy['items-center'],
          sy['gap-4'],
        ]}>
        <EmailIcon
          fill={!is_last_activity ? '#828282' : '#4a4a49'}
          width={18}
          height={18}
        />
        <View
          style={[
            sy['flex-1'],
            sy['flex-row'],
            sy['justify-between'],
            {paddingRight: 10},
          ]}>
          <Text
            style={[sy.smallMedium, !is_last_activity && sy['text-lightgray']]}>
            E-mail verzonden
          </Text>
          <Text style={[sy.small]}>{display_timestamp.format('H:mm')}</Text>
        </View>
      </View>
    );
  }

  return (
    <View
      style={[
        sy['rounded-lg'],
        sy['bg-white'],
        sy['py-2'],
        sy['px-4'],
        sy['flex-row'],
        sy['items-center'],
        sy['gap-4'],
      ]}>
      <ServiceRequestStatusIcon
        status={status}
        fill={!is_last_activity ? '#828282' : null}
        iconProps={{
          width: 18,
          height: 18,
        }}
      />
      <View
        style={[
          sy['flex-1'],
          sy['flex-row'],
          sy['justify-between'],
          {paddingRight: 10},
        ]}>
        <Text
          style={[sy.smallMedium, !is_last_activity && sy['text-lightgray']]}>
          {STATUS_DESCRIPTIONS[status] ?? status}
        </Text>
        <Text style={[sy.small]}>{display_timestamp.format('H:mm')}</Text>
      </View>
    </View>
  );
};

export default Activity;
